import { useEffect, useState } from "react";
import Image from "next/image";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";
import arrow from "@/src/assets/images/svg/arrow-big.svg";

import server from "@/src/api/server";
import Swal from "sweetalert2";

const Form = () => {
  const { formatMessage, locale } = useIntl();

  const [systems, setSystems] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      const systemsResponse = await server.get("/pages/systems");
      const sectionData = (r) => r?.data?.data?.page?.sections || [];
      setSystems(sectionData(systemsResponse));
    })();
  }, []);

  const onSubmit = async (data) => {
    try {
      await server.post("/pages/contact/sections", {
        section: {
          ...data,
          title: data.name,
        },
      });
      reset();
      Swal.fire(
        `${formatMessage({
          id: "thanks",
        })}`,
        `${formatMessage({
          id: "thankMsg",
        })}`,
        "success"
      );
    } catch (error) {
      return;
    }
  };
  return (
    <>
      <div className="order-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col className="p-0">
              <div
                className="form-group"
                data-aos="fade-up"
                data-aos-duration="300"
                data-aos-delay="100"
              >
                <label htmlFor="name">
                  {formatMessage({
                    id: "name",
                  })}
                </label>
                <input
                  id="name"
                  className="form-control border"
                  {...register("name", {
                    required: true,
                  })}
                  // placeholder={formatMessage({
                  //   id: "name",
                  // })}
                />
                {errors?.Name?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="requiredFields" />
                  </p>
                )}
              </div>
              <div
                className="form-group"
                data-aos="fade-up"
                data-aos-duration="300"
                data-aos-delay="200"
              >
                <label htmlFor="phone">
                  {formatMessage({
                    id: "phone",
                  })}
                </label>
                <input
                  id="phone"
                  type="text"
                  className="form-control border"
                  {...register("phone", {
                    required: true,
                  })}
                  // placeholder={formatMessage({
                  //   id: "phone",
                  // })}
                />
                {errors?.phone?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="requiredFields" />
                  </p>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="p-0">
              <div
                className="form-group"
                data-aos="fade-up"
                data-aos-duration="300"
                data-aos-delay="400"
              >
                <label htmlFor="message">
                  {formatMessage({
                    id: "details",
                  })}
                </label>
                <textarea
                  id="message"
                  className="form-control border"
                  {...register("message", {
                    required: true,
                  })}
                  // placeholder={formatMessage({
                  //   id: "details",
                  // })}
                />
                {errors?.email?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="requiredFields" />
                  </p>
                )}
              </div>
            </Col>
          </Row>
          <div
            className="form-group button"
            data-aos="fade-up"
            data-aos-duration="300"
            data-aos-delay="500"
          >
            <button type="submit" className="btn gradient-btn">
              <FormattedMessage id="send" />
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Form;
